<template>
  <div class="message-page">
    <SubPageHeader title="消息通知" />
    
    <div class="message-list">
      <div v-if="isLoading && page === 1" class="state-text">加载中...</div>
      <div v-else-if="messageList.length === 0 && !isLoading" class="state-text">暂无消息通知</div>
      <template v-else>
        <div
          v-for="(item, index) in messageList"
          :key="item.id || index"
          class="message-item"
          @click="handleMessageClick(item)"
        >
          <div class="item-header">
            <div v-if="item.has_read === 0" class="red-dot"></div>
            <div class="item-title">{{ item.title || '消息通知' }}</div>
          </div>
          
          <div v-if="item.content && item.content.length > 0" class="item-content">
            <div v-for="(line, idx) in item.content" :key="idx" class="content-line">{{ line }}</div>
          </div>
          
          <div class="item-info">
            {{ item.create_time }}
          </div>
        </div>
        
        <div v-if="isLoading && page > 1" class="state-text">加载更多中...</div>
        <div v-else-if="isFinished" class="state-text">没有更多数据了</div>
      </template>
    </div>
  </div>
</template>

<script>
import { getMessageList, readMessage } from '@/api'
import SubPageHeader from '../component/SubPageHeader.vue'

export default {
  name: 'MessagePage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      messageList: [],
      isLoading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      isFinished: false
    }
  },
  mounted() {
    this.fetchMessageList()
    const appEl = document.getElementById('app')
    if (appEl) {
      appEl.addEventListener('scroll', this.handleScroll)
    } else {
      window.addEventListener('scroll', this.handleScroll)
    }
  },
  beforeUnmount() {
    const appEl = document.getElementById('app')
    if (appEl) {
      appEl.removeEventListener('scroll', this.handleScroll)
    } else {
      window.removeEventListener('scroll', this.handleScroll)
    }
  },
  methods: {
    handleScroll() {
      const appEl = document.getElementById('app') || document.documentElement
      const scrollTop = appEl.scrollTop || window.scrollY
      const scrollHeight = appEl.scrollHeight || document.documentElement.scrollHeight
      const clientHeight = appEl.clientHeight || window.innerHeight
      
      if (scrollTop + clientHeight >= scrollHeight - 50) {
        this.loadMore()
      }
    },
    loadMore() {
      if (this.isLoading || this.isFinished) return
      this.page += 1
      this.fetchMessageList(true)
    },
    async fetchMessageList(isLoadMore = false) {
      if (!isLoadMore) {
        this.page = 1
        this.isFinished = false
      }
      this.isLoading = true
      try {
        const res = await getMessageList({
          page: this.page,
          pageSize: this.pageSize
        })
        let list = []
        let total = 0
        if (Array.isArray(res?.data)) {
          list = res.data
        } else if (Array.isArray(res?.data?.list)) {
          list = res.data.list
          total = res.data.total || 0
        } else if (Array.isArray(res?.data?.records)) {
          list = res.data.records
          total = res.data.total || 0
        } else if (Array.isArray(res?.data?.rows)) {
          list = res.data.rows
          total = res.data.total || 0
        }
        
        this.total = total
        
        if (isLoadMore) {
          this.messageList = [...this.messageList, ...list]
        } else {
          this.messageList = list
        }
        
        if (this.messageList.length >= this.total || list.length === 0) {
          this.isFinished = true
        } else {
          this.isFinished = false
        }
      } catch (error) {
        if (!isLoadMore) {
          this.messageList = []
        }
      } finally {
        this.isLoading = false
        this.$nextTick(() => {
          if (!isLoadMore) {
            this.restoreScrollPosition()
          }
        })
      }
    },
    getScrollPosition() {
      // 从 #app 容器获取滚动位置
      const appEl = document.getElementById('app')
      return appEl ? appEl.scrollTop : 0
    },
    setScrollPosition(y) {
      // 恢复 #app 容器的滚动位置
      const appEl = document.getElementById('app')
      if (appEl) {
        appEl.scrollTop = y
      }
    },
    restoreScrollPosition() {
      const scrollY = sessionStorage.getItem('messagePageScrollY')
      if (!scrollY) return
      
      const targetY = parseInt(scrollY, 10)
      if (targetY > 0) {
        this.setScrollPosition(targetY)
        sessionStorage.removeItem('messagePageScrollY')
      }
    },
    async handleMessageClick(item) {
      // 记录当前滚动位置，兼容不同浏览器的获取方式以及内部容器滚动
      const scrollY = this.getScrollPosition()
      sessionStorage.setItem('messagePageScrollY', scrollY)

      // 如果未读，则请求标记为已读
      if (item.has_read === 0) {
        try {
          await readMessage({ id: item.id })
          item.has_read = 1
        } catch (error) {
          console.error('标记已读失败', error)
        }
      }
      
      // 根据消息类型跳转到对应的详情页
      // if (item.category === 'notification' || item.category === 'article') {
      //   if (item.obj_id) {
      //     this.$router.push({
      //       path: '/home/article/detail',
      //       query: { articleId: item.obj_id }
      //     })
      //   }
      // } else if (item.category === 'meeting') {
      //   if (item.obj_id) {
      //     this.$router.push({
      //       path: '/organize/meeting/detail',
      //       query: { id: item.obj_id }
      //     })
      //   }
      // }
      
      // 保存消息内容到本地存储并跳转到消息详情页
      sessionStorage.setItem('currentMessageDetail', JSON.stringify(item))
      this.$router.push('/home/message/detail')
    }
  }
}
</script>

<style lang="scss" scoped>
.message-page {
  min-height: 100vh;
  background-color: #f8f9fa;
  display: flex;
  flex-direction: column;
}

.message-list {
  padding: 4vw;
  flex: 1;
}

.state-text {
  text-align: center;
  color: #999;
  font-size: 3.5vw;
  padding: 10vw 0;
}

.message-item {
  background-color: #fff;
  border-radius: 2vw;
  padding: 4vw;
  margin-bottom: 4vw;
  box-shadow: 0 1vw 2vw rgba(0, 0, 0, 0.05);
  cursor: pointer;

  .item-header {
    display: flex;
    align-items: flex-start;
    margin-bottom: 2vw;

    .red-dot {
      width: 2vw;
      height: 2vw;
      background-color: #f5222d;
      border-radius: 50%;
      margin-top: 1.5vw;
      margin-right: 2vw;
      flex-shrink: 0;
    }

    .item-title {
      font-size: 3.8vw;
      color: #333;
      font-weight: bold;
      line-height: 1.4;
      flex: 1;
    }
  }

  .item-content {
    margin-top: 2vw;
    margin-bottom: 2vw;
    padding-left: 4vw;
    
    .content-line {
      font-size: 3.5vw;
      color: #666;
      line-height: 1.5;
      margin-bottom: 0.5vw;
    }
  }

  .item-info {
    font-size: 3.2vw;
    color: #999;
    margin-top: 2vw;
    padding-left: 4vw;
  }
}
</style>
